import React from 'react'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import { track } from '@amplitude/analytics-browser'
import { Link as RouterLink } from 'react-router-dom'
import translator from 'src/translate'

const UpgradeButton = () => (
  <CoreButton
    to="/pricing"
    variant="outlined"
    startIcon={
      <Icon size="small" icon="fa6-solid:crown" color="#f7b155" width={15} />
    }
    component={RouterLink}
    onClick={() =>
      track('limit_warning_upgrade', { from: 'dashboard_upgrade_button' })
    }
  >
    {translator._('general.upgrade')}
  </CoreButton>
)

export default UpgradeButton
